import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Role } from '../../../../../models/Role';

export interface DeleteRoleDialogData {
  role: Role;
}

@Component({
  selector: 'app-delete-role-dialog',
  templateUrl: './delete-role-dialog.component.html',
  styleUrls: ['./delete-role-dialog.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogModule
  ]
})
export class DeleteRoleDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DeleteRoleDialogData,
    public dialogRef: MatDialogRef<DeleteRoleDialogComponent>
  ) { }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }
}
